import { useEffect } from 'react';
import './App.css';

// MUI
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// App
import {AppCtxProvider}  from './app/AppCtx';
import {CodeCtxProvider} from './app/CodeCtx';
import {CrewCtxProvider} from './app/CrewCtx';

import {AppHead} from './app/AppHead';
import {AppMain} from './app/AppMain';
import {AppTail} from './app/AppTail';

function App() {

    // Hook to prevent browser back/refresh/close
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ""; // Required for Chrome
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    return (
      <AppCtxProvider>
          <CodeCtxProvider>
              <CrewCtxProvider>
                  <div id="app" className="App">
                      <AppHead />
                      <AppMain />
                      <AppTail />
                  </div>
              </CrewCtxProvider>
          </CodeCtxProvider>
      </AppCtxProvider>
    );
}

export default App;
